import React, { useState } from "react";
import { Grid, Container, TextField } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useNavigate, useParams } from "react-router-dom";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import CustomButton from "../../components/Custom/CustomButton";
import { useTranslation } from "react-i18next";
export default function CreateHarvestSale() {
  const { harvestId } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const createLabTest = () => {
    const fileFields = [];
    formData["harvest"] = harvestId;
    const _formData = new FormData();
    for (const key in formData) {
      if (formData[key] instanceof FileList) {
        _formData.append(key, formData[key][0]);
      } else {
        if (fileFields.includes(key) && typeof formData[key] === "string")
          continue;
        _formData.append(key, formData[key]);
      }
    }

    api
      .post("/farmer/harvest_sales/", _formData)
      .then((response) => {
        console.log(response.data);
        alert("Harvest added successfully");
        navigate("/farmer/harvests");
      })
      .catch((error) => {
        console.log(error);
        alert("Error adding harvest: " + error);
      });
  };

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <div>
          <Grid
            container
            // spacing={1}
            justify="center"
            direction="column"
            style={{ marginTop: "10px" }}
          >
            <CustomTitle>{t("Add Harvest Sale")}</CustomTitle>

            <TextField
              margin="normal"
              required
              fullWidth
              label={t("Sold To")}
              name="sold_to"
              value={formData.sold_to || ""}
              onChange={handleChange}
            />

            <TextField
              margin="normal"
              required
              fullWidth
              label={t("Quantity(kg)")}
              type="number"
              name="quantity"
              value={formData.quantity || ""}
              onChange={handleChange}
            />

            <CustomButton onClick={createLabTest}>{t("Add Sale")}</CustomButton>
          </Grid>
        </div>
      </Container>
    </>
  );
}
